import { createErrorButton, createErrorFlag } from './create';
import { toggleErrorStatus } from './methods';

export default {
    createErrorButton, 
    createErrorFlag,
    toggleErrorStatus,
}